//
// WooCommerce
//

/// <reference types="jquery" />

jQuery(document.body).on('wc_cart_button_updated', () => {
  jQuery('.added_to_cart.wc-forward').remove()
})
